/* global __NAMESPACE__ */
/* eslint-disable max-params */

import styles from '../shared/index.css'
import {
  backgrounds,
  visible,
  superoverlay
} from '../shared/stylesheets/background.css'
import videoStyles from '../shared/stylesheets/video.css'
import {
  loadSections
} from './sections/index'
import {
  observer
} from './intersection'
import {
  getMutedButton,
  getUnmutedButton
} from './utils/muteButtons'
import {
  gaInitialize,
  trackAction
} from "./utils/googleAnalytics";

export default class App {
  constructor(params, container) {
    this.params = params
    this.container = container
    this.error = null
    this.muted = true
    this.videoElements = []

    this.toggleMuteVideo = this.toggleMuteVideo.bind(this)

    this.gaInitialized = false
    this.sectionId = 0
  }

  setSectionId = (id) => {
    this.sectionId = id
  }

  mount() {
    try {
      this.initializeGoogleAnalytic()
      this.render()
      this.mountListeners()
    } catch (error) {
      document.body.innerHTML = `${JSON.stringify(error)}`
    }


    const videoes = [...document.querySelectorAll('video')]
    this.videoElements = videoes
    videoes.forEach(v => v.pause())

    const sectionEls = [...document.querySelectorAll(`.${styles.section}`)]

    const shareButtons = document.querySelector(`.${styles.shareButtonGroup}`)
    this.shareButtons = shareButtons

    //initiallyVisible(sectionEls)
    observer(sectionEls, this.videoElements, this.muteButton, this.shareButtons, this.setSectionId)
  }

  initializeGoogleAnalytic() {
    if (!this.gaInitialized) {
      gaInitialize(this.container.getAttribute('data-tracking'))
    }
    this.gaInitialized = true
  }

  unmount() {
    this.unmountListeners()
    this.container.innerHTML = ''
  }

  mountListeners() {
    // Implement `addEventListener` here
    const muteButton = document.querySelector(`.${videoStyles["video-mute-button"]}`)
    this.muteButton = muteButton

    this.muteButton.addEventListener('click', this.toggleMuteVideo, false)
  }

  unmountListeners() {
    // Implement `removeEventListener` here
  }

  render() {
    if (this.error) {
      this.renderError()
      return
    }

    const backgroundContainer = document.querySelector(`.${backgrounds}`)
    const overlayContainer = document.querySelector(`.${superoverlay}`)
    const sectionElements = Array.prototype.slice.call(document.querySelectorAll(`.${styles.section}`))

    loadSections(sectionElements, backgroundContainer, overlayContainer)

  }

  updateSuperOffest() {
    let offset = 0;

    [...document.querySelectorAll(`.${styles.super__content}`)]
    .reverse()
      .filter((content) => content.style.display === 'block')
      .forEach((content) => {
        content.style.transform = `translateY(-${offset}px)`
        offset += content.offsetHeight
      })
  }

  renderError() {
    this.container.innerHTML = (
      `<pre class="${__NAMESPACE__}-App--error">${this.error.stack}</pre>`
    )
  }
  toggleMuteVideo(e) {
    e.stopPropagation()
    const parentElement = e.target.parentElement
    const videoElement = parentElement.querySelector('video')

    if (this.muted) {
      this.videoElements.forEach(v => v.muted = false)
      this.muteButton.innerHTML = getUnmutedButton()
      this.muted = false
      trackAction(`UNMUTE/${this.sectionId}`)
      return
    } else {
      this.videoElements.forEach(v => v.muted = true)
      this.muteButton.innerHTML = getMutedButton()
      this.muted = true
      trackAction(`MUTE/${this.sectionId}`)
      return
    }
  }
}



window.App = App







//picturefill()



// WEBPACK FOOTER //
// ./src/client/index.js